import colors from "@tokens/web/colors.json";

const useDesignTokens = () => {
  return { colors };
};

export default useDesignTokens;
